import React, {useState} from 'react';
import Login from "./form/Login";
import Button from "../../ui/Button";
import Registration from "./form/Registration";
import {useTranslation} from "react-i18next";
import {authLookupAC} from "../../../redux/auth/auth-action";
import {useDispatch} from "react-redux";
import {LoginSocialFacebook, LoginSocialGoogle} from "reactjs-social-login";
import {FacebookLoginButton, GoogleLoginButton} from "react-social-login-buttons";
import {facebookLoginThunk, googleLoginThunk} from "../../../redux/auth/auth-thunk";
import {toast} from "react-toastify";
import LoginSocialModal from "../../Modal/LoginSocialModal";

const OrderServicesTab = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [isLogin, setIsLogin] = useState(true);
    const onSwitchTab = (value) => {
        setIsLogin(value);
        dispatch(authLookupAC({isLoading: false, data: null, error: null, isError: false}))
    }

    return (
        <>{isLogin ?
            <Login onSwitchTab={onSwitchTab}>
                <div className="d-flex justify-center flex-wrap gap-10">
                    <LoginSocialGoogle key={'login-social-google'}
                                       client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                                       isOnlyGetToken={true}
                                       isOnlyGetCode={true}
                                       auto_select={false}
                                       scope={'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'}
                                       cookie_policy={false}
                                       onResolve={async ({provider, data}) => {
                                           dispatch(googleLoginThunk(data.access_token))
                                           // dispatch(accountConnectedGoogle(data.access_token))
                                       }}
                                       onReject={(err) => {
                                           console.log(err)
                                           toast.error(err);
                                       }}>
                        <GoogleLoginButton text={"Google"} key={'login-social-google-btn'}/>
                    </LoginSocialGoogle>
                    <LoginSocialFacebook
                        fieldsProfile={"id,name,email"}
                        fields="first_name,last_name,email,name"
                        scope="public_profile,email"
                        returnScopes={true}
                        appId={process.env.REACT_APP_FACEBOOK_CLIENT_ID}
                        onResolve={(response) => {
                            console.log(response);
                            dispatch(facebookLoginThunk(response.data))
                        }}
                        onReject={(error) => {
                            console.log(error);
                            toast.error(error);
                        }}
                    >
                        <FacebookLoginButton text={"Facebook"}/>
                    </LoginSocialFacebook>
                </div>
            </Login>
            :
            <Registration onSwitchTab={onSwitchTab}>
                <Button className={'w-100 justify-center btn-revert'} type={'button'}
                        onClick={() => onSwitchTab(true)}><>{t('login_page.login')}</>
                </Button>
            </Registration>
        }
            <LoginSocialModal/>
        </>
    );
};

export default OrderServicesTab;